import { adjustPullAsync, adjustPushAsync } from "./adjust";
import {
  reassignManningVesselCrewIdByCrewModeAsync,
  reassignManningVesselCrewIdByVesselModeAsync,
} from "./reassign";
import { processOverlappingEventsAsync } from "./overlapping";
import { concateEventsAsync } from "./concat";
import C from "../Constants";
import EventHelperCommon from "../scheduler-event-helper/common";
import EventHelperVessel from "../scheduler-event-helper/vessel";

export default displayMode => {
  const _displayMode = displayMode;

  return async (project, changes) => {
    const eventStore = project.eventStore;
    // 追加、変更されたイベント差分を取得
    const { added, modified, removed } = changes;

    // イベントが追加された場合
    if (added.length > 0) {
      for (const event of added) {
        // 計画中,休暇希望はスキップ
        if (
          event.scheduling_status === C.SCHEDULING_STATUS.PLANNING ||
          event.event_type === C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST
        ) {
          continue;
        }

        await _processEventAsync(event, eventStore, _displayMode);
      }
    }

    // イベントが編集された場合
    if (modified.length > 0) {
      for (const event of modified) {
        // 計画中,休暇希望はスキップ
        if (
          event.scheduling_status === C.SCHEDULING_STATUS.PLANNING ||
          event.event_type === C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST
        ) {
          continue;
        }

        await _processEventAsync(event, eventStore, _displayMode);
      }
    }

    // イベントが削除された場合
    // 同じ乗船期間IDのイベントは全て削除
    if (removed.length > 0) {
      for (const event of removed) {
        // 計画中,船上イベント以外はスキップ
        if (
          event.scheduling_status === C.SCHEDULING_STATUS.PLANNING ||
          event.event_type !== C.SCHEDULING_EVENT_TYPE.VESSEL
        ) {
          continue;
        }

        await _processVesselEventDeletedAsync(event, eventStore);
      }
    }
  };
};

const _processEventAsync = async (editedEvent, eventStore, displayMode) => {
  let targetEvents = [];
  if (displayMode === C.DISPLAY_MODE.CREWS) {
    // 乗員モードの場合は、乗員様態のイベントを取得
    targetEvents = _getTargetEventsByCrewMode(eventStore, editedEvent);
  } else {
    // 船舶モードの場合は、船舶様態のイベントを取得
    targetEvents = _getTargetEventsByVesselMode(eventStore, editedEvent);
  }

  const resourceId = editedEvent.resourceId;
  // 重なっているイベントを処理
  // 削除、分割処理を行う
  await processOverlappingEventsAsync(
    editedEvent,
    targetEvents,
    eventStore,
    displayMode
  );

  // イベントサイズ調整
  await adjustPushAsync(editedEvent, targetEvents);
  await adjustPullAsync(editedEvent, targetEvents);

  if (displayMode === C.DISPLAY_MODE.CREWS) {
    // 乗船期間IDを振り直す
    await reassignManningVesselCrewIdByCrewModeAsync(eventStore, resourceId);
  } else {
    const rootResourceId = EventHelperVessel.getRootResource(
      editedEvent.resource
    ).id;
    const crewId = editedEvent.crew_id;
    // 船舶モードの場合は、乗船期間IDを振り直す
    await reassignManningVesselCrewIdByVesselModeAsync(
      eventStore,
      rootResourceId,
      crewId
    );
  }
  // イベントのコピーと削除を適用
  await EventHelperCommon.applyReplaceAndDeleteAsync(eventStore);

  // イベント結合
  await concateEventsAsync(eventStore, resourceId);
  // イベントのコピーと削除を適用
  await EventHelperCommon.applyReplaceAndDeleteAsync(eventStore);
};

const _processVesselEventDeletedAsync = async (deletedEvent, store) => {
  let targetEvents = store.query(event => {
    return (
      deletedEvent.enterprise_manning_vessel_crew_id ===
      event.enterprise_manning_vessel_crew_id
    );
  });

  if (targetEvents.length === 0) {
    return;
  }

  targetEvents.push(deletedEvent);
  targetEvents.sort(EventHelperCommon.sortByStartDate);

  const deletedEventIndex = targetEvents.findIndex(
    event => event.id === deletedEvent.id
  );

  if (deletedEventIndex <= 0) {
    return;
  }

  const targetEvent = targetEvents[deletedEventIndex - 1];
  await targetEvent.setEndDate(deletedEvent.endDate, false);
};

/**
 *
 * @param {*} store イベントストア
 * @param {*} editedEvent 変更されたイベント
 * @param {*} isActiveOnly 削除フラグが立っていないイベントのみを対象とするか
 * @returns
 */
const _getTargetEventsByCrewMode = (store, editedEvent) => {
  return store.query(event => {
    return (
      EventHelperCommon.isScheduled(event) &&
      event.event_type !== C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST &&
      event.resourceId === editedEvent.resourceId &&
      event.id !== editedEvent.id &&
      !EventHelperCommon.isSoftDeleted(event)
    );
  }, true);
};

/**
 *
 * @param {*} store イベントストア
 * @param {*} editedEvent 変更されたイベント
 * @returns
 */
const _getTargetEventsByVesselMode = (store, editedEvent) => {
  return store.query(event => {
    return (
      EventHelperCommon.isScheduled(event) &&
      event.crew_id === editedEvent.crew_id &&
      event.id !== editedEvent.id &&
      !EventHelperCommon.isSoftDeleted(event)
    );
  }, true);
};
